var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPencil3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2276 3.56925C20.4722 3.46681 20.7348 3.41406 21 3.41406C21.2652 3.41406 21.5278 3.46681 21.7724 3.56925C22.0156 3.67108 22.2363 3.82 22.4217 4.00742L27.9925 9.57813C28.1799 9.76356 28.3288 9.98423 28.4306 10.2275C28.5331 10.4721 28.5858 10.7347 28.5858 10.9999C28.5858 11.2651 28.5331 11.5277 28.4306 11.7723C28.3288 12.0155 28.1799 12.2362 27.9925 12.4216L12.7071 27.707C12.5196 27.8945 12.2652 27.9999 12 27.9999H6C5.46957 27.9999 4.96086 27.7892 4.58579 27.4141C4.21071 27.039 4 26.5303 4 25.9999V20.4138M20.2276 3.56925C19.9843 3.6711 19.7636 3.82005 19.5782 4.00751L20.2276 3.56925ZM6 20.4141V25.9999H11.5858L26.5858 10.9999L26.5804 10.9945L21 5.41408L20.9946 5.41952L6 20.4141Z",
    fill: "#2F3941"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2929 7.29289C16.6834 6.90237 17.3166 6.90237 17.7071 7.29289L24.7071 14.2929C25.0976 14.6834 25.0976 15.3166 24.7071 15.7071C24.3166 16.0976 23.6834 16.0976 23.2929 15.7071L16.2929 8.70711C15.9024 8.31658 15.9024 7.68342 16.2929 7.29289Z",
    fill: "#2F3941"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35539 19.3554C4.74592 18.9649 5.37908 18.9649 5.76961 19.3554L12.4142 26H27C27.5523 26 28 26.4477 28 27C28 27.5523 27.5523 28 27 28H12C11.7348 28 11.4804 27.8946 11.2929 27.7071L4.35539 20.7696C3.96487 20.3791 3.96487 19.7459 4.35539 19.3554Z",
    fill: "#2F3941"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2071 10.7929C21.5976 11.1834 21.5976 11.8166 21.2071 12.2071L9.20711 24.2071C8.81658 24.5976 8.18342 24.5976 7.79289 24.2071C7.40237 23.8166 7.40237 23.1834 7.79289 22.7929L19.7929 10.7929C20.1834 10.4024 20.8166 10.4024 21.2071 10.7929Z",
    fill: "#2F3941"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil3);
export default __webpack_public_path__ + "static/media/icon_pencil3.38e218b22c769d069520b32d9a4a8840.svg";
export { ForwardRef as ReactComponent };